import React, { useState } from 'react';
import { Instagram, Music as MusicIcon, Play, ArrowRight } from 'lucide-react';
import { SOCIAL_LINKS } from '../mock/mock';
import { toast } from 'sonner';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const onSubmit = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast('Please enter a valid email');
      return;
    }
    toast('¡Bienvenida, Princesa! Check your inbox for a surprise.');
    setEmail('');
  };

  return (
    <section className="bg-pink-hot text-cream py-20 md:py-24 relative overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 grid grid-cols-12 gap-6 md:gap-10 items-center">
        <div className="col-span-12 md:col-span-7">
          <p className="font-anton uppercase tracking-[0.3em] text-cream/80 text-xs mb-4">— Newsletter</p>
          <h2 className="mega text-cream text-5xl md:text-7xl lg:text-8xl">Join the Club</h2>
          <p className="font-body text-cream/90 mt-5 max-w-xl text-base md:text-lg">
            Fechas, drops exclusivos y códigos secretos. Sólo para la familia de Mariah.
          </p>
        </div>
        <div className="col-span-12 md:col-span-5">
          <form onSubmit={onSubmit} className="flex bg-cream text-brown rounded-full overflow-hidden">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              className="flex-1 px-5 py-4 bg-transparent outline-none font-body text-sm"
            />
            <button type="submit" className="bg-brown text-cream px-6 font-anton uppercase tracking-widest text-xs inline-flex items-center gap-2 hover:bg-brown-deep transition-colors rounded-full">
              Sign Up <ArrowRight className="w-4 h-4" />
            </button>
          </form>
          <div className="mt-6 flex items-center gap-4">
            <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 font-anton uppercase tracking-widest text-xs hover:underline">
              <Instagram className="w-4 h-4" /> Instagram
            </a>
            <a href={SOCIAL_LINKS.spotify} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 font-anton uppercase tracking-widest text-xs hover:underline">
              <MusicIcon className="w-4 h-4" /> Spotify
            </a>
            <a href={SOCIAL_LINKS.link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 font-anton uppercase tracking-widest text-xs hover:underline">
              <Play className="w-4 h-4" /> Pre-save
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
